"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { Suspense, useTransition } from "react";

type Props = {
  paramName: string | string[];
  children?: React.ReactNode;
};

function Delete({ paramName, children }: Props) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [isPending, startTransition] = useTransition();
  const handle = () => {
    startTransition(() => {
      const params = new URLSearchParams(searchParams.toString());
      typeof paramName === "string" ? params.delete(paramName) : paramName.forEach((f) => params.delete(f));
      router.replace("?" + params.toString(), { scroll: false });
    });
  };
  return (
    <a
      onClick={handle}
      role="button"
      tabIndex={0}
      className={`w-full h-full mx-auto my-auto ${isPending && "bg-gray-500/80 skeleton rounded-none"}`}
    >
      {children}
    </a>
  );
}

export default function DeleteSearchParam(param: Props) {
  return (
    <Suspense fallback={param.children}>
      <Delete {...param} />
    </Suspense>
  );
}
